import { render, staticRenderFns } from "./customer_unit.vue?vue&type=template&id=44bf71f8"
import script from "./customer_unit.vue?vue&type=script&lang=js"
export * from "./customer_unit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports